import React, { useEffect, useState } from 'react'
import { Button, ThinButton } from '../../../components/buttons';
import { HtmlTooltip, InputContainer, StyledInput } from '../../../components/InputField';
import { updateInsuranceFee } from '../../../redux/reducers/deeleeoReducer';
import { connect } from 'react-redux';
import InfoIcon from "../../../assets/icons/Info-icon.svg";



const InsuranceSingle = (props) => {
    const { userData, deeleeoDetail, updateInsuranceFee } = props;
    const [addInsurance, setAddInsurance] = useState(false);
    const [insuranceValue, setInsuranceValue] = useState(userData.defaultInsuranceValue);
    const [extraFee, setExtraFee] = useState(0);
    const FIXED_INSURANCE_PERCENTAGE = 0.03;
    const handleButtonClick = () => {
        if (addInsurance) {

        }

        setAddInsurance(!addInsurance);
    }
    const handleOnChange = (e) => {
        const value = parseInt(e.target.value);
        setInsuranceValue(value);
        const diff = value - userData.defaultInsuranceValue;
        if (diff > 0) {
            setExtraFee(diff * FIXED_INSURANCE_PERCENTAGE)
        } else {
            setExtraFee(0);
        }

    }

    const handleConfirm = (e) => {
        updateInsuranceFee(insuranceValue);
        setAddInsurance(false)
    }

    useEffect(() => {
        if (deeleeoDetail.insurance_value < userData.defaultInsuranceValue) {
            updateInsuranceFee(userData.defaultInsuranceValue);
        }
    }, [deeleeoDetail.insurance_value, updateInsuranceFee, userData.defaultInsuranceValue]);

    return (
        <div>
            <div>Insured Value of Goods: ${deeleeoDetail.insurance_value}.
                <HtmlTooltip
                    style={{ marginLeft: 7 }}
                    placement="top"
                    title={`By default, we insure up to $${deeleeoDetail.insurance_value} per delivery. By adding and purchasing additional package insurance, this insures that if your package(s) were to get damaged or lost, the value of goods will be covered up to the total value of goods you identify here.`}>

                    <img
                        style={{ display: 'inline' }}
                        className="-mt-1 ml-1"
                        src={InfoIcon}
                        alt={"premium information"}
                    />
                </HtmlTooltip>
                <Button
                    onClick={handleButtonClick}
                >Add additional package insurance
                </Button>
            </div>
            {
                addInsurance &&
                <>
                    <InputContainer className='w-1/3'>
                        <label>Total value of goods:</label>
                        <StyledInput

                            id='insurance'
                            label='insurance'
                            type='number'
                            onChange={handleOnChange}
                            onBlur={handleOnChange}
                            value={insuranceValue}
                            min={userData.defaultInsuranceValue}
                            maxWith={'1rem'}
                            step={10}
                        />

                    </InputContainer>
                    <InputContainer className='w-1/3'>
                        {insuranceValue > userData.defaultInsuranceValue && <div>Premium: ${extraFee.toFixed(2)}</div>}
                    </InputContainer>
                    <ThinButton
                        onClick={handleConfirm}
                    >Confirm</ThinButton>
                </>

            }
        </div>
    );
}

const mapStateToProps = state => ({
    userData: state.userReducer,
    deeleeoDetail: state.deeleeoReducer,
})

const mapDispatchToProps = dispatch => ({
    updateInsuranceFee: (fee) => dispatch(updateInsuranceFee(fee)),
})

export default connect(mapStateToProps, mapDispatchToProps)(InsuranceSingle);